import { FunctionComponent, useEffect, useState, ReactNode } from 'react';
import styles from './Toast.module.scss';
import { withStyles } from '../../../utils/utils';

export type ToastProps = {
  variant?: 'success' | 'neutral';
  label: ReactNode;
  isVisible: boolean;
  timerTime?: number;
  hasCloseButton?: boolean;
  closeButtonPosition?: 'center' | '';
  textColor?: string;
  backgroundColor?: string;
  position?: 'right' | 'top' | 'bottom';
  className?: string;
  indefinite?: boolean;
  onClose?: () => void;
};

type FC = FunctionComponent<ToastProps>;

const cn = withStyles(styles);

const Toast: FC = ({
  variant = 'success',
  label,
  isVisible = false,
  timerTime = 4000,
  hasCloseButton = false,
  closeButtonPosition = '',
  textColor,
  backgroundColor,
  position = 'bottom',
  className,
  indefinite = false,
  onClose = () => {},
}: ToastProps) => {
  const [visible, setVisible] = useState(false);
  const [displayStyle, setDisplayStyle] = useState('block');

  useEffect(() => {
    if (isVisible) {
      setVisible(true);

      if (!indefinite) {
        setTimeout(() => {
          setVisible(false);
        }, timerTime);
      }
    } else {
      setVisible(false);
    }
  }, [isVisible]);

  useEffect(() => {
    if (!visible) {
      onClose();
    }
  }, [visible]);

  const closeToastHandler = () => {
    setDisplayStyle('none');
    onClose();
  };

  return (
    <div
      className={cn('toastContainer', position, visible && 'visible', variant, className)}
      style={{ display: displayStyle, backgroundColor, color: textColor }}
    >
      {label}

      {hasCloseButton && (
        <button className={cn('toastCloseButton', closeButtonPosition)} onClick={closeToastHandler}>
          x
        </button>
      )}
    </div>
  );
};

export default Toast;
